module.exports = __webpack_public_path__ + "img/dage.7056c364.png";